
export class LeveransQuery {
    periodFrom?: string;
    periodTom?: string;
    leveransnummer?: string;
    mottagningsplatsId?: number;
    fritext?: string;
    datakalla: "Alla" | "Viol2" | "Viol3";

    constructor(datakalla) {
        this.datakalla = datakalla;
    }
}
